import React from "react";
import Particles from "react-tsparticles";

import "./comingsoon.styles.css";
import logo from "../../assets/krb2.png";

const IconMail = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3.5 7.5 12 13l8.5-5.5" />
  </svg>
);

const IconPin = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M12 21s-6.5-5-6.5-10.5a6.5 6.5 0 1 1 13 0C18.5 16 12 21 12 21z" />
    <circle cx="12" cy="10.5" r="2.4" />
  </svg>
);

const ComingSoon = () => {
  return (
    <>
      <Particles
        id="tsparticles"
        options={{
          particles: {
            number: { value: 25, density: { enable: true, value_area: 800 } },
            color: { value: "#ffffff" },
            shape: {
              type: "circle",
              stroke: { width: 0, color: "#000000" },
              polygon: { nb_sides: 1 },
            },
            opacity: { value: 0.5, random: false },
            size: { value: 3, random: true },
            line_linked: {
              enable: true,
              distance: 200,
              color: "#ffffff",
              opacity: 0.4,
              width: 1,
            },
            move: {
              enable: true,
              speed: 2,
              direction: "none",
              random: false,
              straight: false,
              out_mode: "out",
              bounce: false,
              attract: { enable: false, rotateX: 600, rotateY: 1200 },
            },
          },
        }}
      />
      <div className="os-phrases" id="os-phrases">
        <h2 style={{ opacity: 1 }}>
          <span className="word1">
            <span className="char1"><span className="char1">P</span></span>
            <span className="char2"><span className="char1">r</span></span>
            <span className="char3"><span className="char1">ó</span></span>
            <span className="char4"><span className="char1">x</span></span>
            <span className="char5"><span className="char1">i</span></span>
            <span className="char6"><span className="char1">m</span></span>
            <span className="char7"><span className="char1">a</span></span>
            <span className="char8"><span className="char1">m</span></span>
            <span className="char9"><span className="char1">e</span></span>
            <span className="char10"><span className="char1">n</span></span>
            <span className="char11"><span className="char1">t</span></span>
            <span className="char12"><span className="char1">e</span></span>
          </span>{" "}
        </h2>
      </div>

      <div className="container-image">
        <img src={logo} className="blur" alt="logo" />
      </div>

      <div className="container-info">
        <span className="contact-overline">Contacto</span>
        <div className="contact-list">
          <a
            className="contact-row"
            href="mailto:krebor@krebor.es"
            aria-label="Enviar correo a krebor@krebor.es"
          >
            <IconMail />
            <span>krebor@krebor.es</span>
          </a>
          <a
            className="contact-row"
            href="https://goo.gl/maps/PFtC8yWFrPTUeyBdA"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Ver ubicación en Google Maps"
          >
            <IconPin />
            <span>Cómo llegar</span>
          </a>
        </div>
      </div>
    </>
  );
};

export default ComingSoon;
